import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

import { FormsModule }   from '@angular/forms';
import { TabsModule } from 'ng2-bootstrap/tabs'; 
// Modal Component
import { ModalModule } from 'ng2-bootstrap/modal'; 

// Components Routing
import { SystemsRoutingModule } from './systems-routing.module'; 
 
import { ParametersComponent } from './parameters.component'; 
import { AddparameterComponent } from './addparameter.component'; 
import { ViewparameterComponent } from './viewparameter.component';  

@NgModule({
  imports: [
    SystemsRoutingModule, 
    ModalModule.forRoot(),
    TabsModule, 
    CommonModule,
    
    FormsModule
  ],
  declarations: [ 
      ViewparameterComponent,
      ParametersComponent,
      AddparameterComponent 
  ],
  providers: [
     
  ]
})
export class SystemsModule { }



// WEBPACK FOOTER //
// ./src/app/systems/systems.module.ts